import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonModal,
  IonPage,
  IonRow,
} from "@ionic/react";
import React, { useState } from "react";
import TopLeftUserName from "../components/TopLeftUserName";
import DuplicateExercisesCard from "./DuplicateExercisesCard";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  allExercisesState,
  duplicateExercisePlanState,
  networkConnectionStatus,
  PatientState,
} from "../data/atoms";
import { useHistory, useLocation } from "react-router";
import {
  GenerateExercisePlanPdf,
  SaveRecommendedExercises,
} from "../services/ExercisesService";
import { localDateTime } from "../utils/sharedFunction";
import { ActionType } from "../models/Enums";
import { printPdfForMobile } from "../utils/mobile-bridge";
import SuccessModal from "../components/modals/success-modal";
import { PatientVM } from "../models/PatientVM";

interface Props {
  visitData: any;
}
const DuplicateExercises: React.FC<Props> = ({ visitData }) => {
  const previousExercise = useRecoilValue(duplicateExercisePlanState);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [printModal, setPrintModal] = useState<boolean>(false);
  const [printActionModal, setPrintActionModal] = useState<number>(
    ActionType.SuccessPrintExercisePlan,
  );
  const [printingModal, setPrintingModal] = useState<boolean>(false);
  let history = useHistory();
  const [printDisable, setPrintDisable] = useState<boolean>(false);
  const allExercises = useRecoilValue(allExercisesState);
  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);
  const [patientDetails, setPatientDetails] =
    useState<PatientVM>(patientDetailsRecoil);

  const printPDF = async () => {
    if (previousExercise.exercises.length === 0) {
      return;
    }

    debugger;

    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }

    setPrintingModal(true);
    // const exerciseDetails: any[] = previousExercise.exercises.map(
    //   (item: any) => ({
    //     ExerciseId: item.testExercises[0].id,
    //     VBTestLookupId: item.testExercises[0].vbTestLookupId,
    //     MobilityLevelId: item.testExercises[0].mobilityLevelId,
    //     NoOfSets: item.testExercises[0].noOfSets,
    //     NoOfDays: item.testExercises[0].noOfDays,
    //     NoOfTimes: item.testExercises[0].noOfTimes,
    //     RepsOrDuration: item.testExercises[0].repsOrDuration,
    //     RepsOrDurationUnits: item.testExercises[0].repsOrDurationUnits,
    //     FrequencyId: item.testExercises[0].frequencyId,
    //     NoOfWeeks: item.testExercises[0].noOfWeeks,
    //     RepsId:
    //       item.testExercises[0].repsId == null
    //         ? 0
    //         : item.testExercises[0].repsId,
    //     Hold: item.testExercises[0].hold,
    //     Weight: item.testExercises[0].weight,
    //     PatientId: +localStorage.getItem("patientServerID")!,
    //     LocalDateTimeString: localDateTime(),
    //   })
    // );
    try {
      //  const response = await SaveRecommendedExercises({ exerciseDetails });
      const reportData = await generateExercisePlanPdf(visitData.visitData);
      // printPdfForMobile(pdfBase64);
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  const generateExercisePlanPdf = async (visitId: any) => {
    debugger;
    const datetoPass: string = visitData.visitData.recommendationDate.substring(
      0,
      10,
    ); // "2023-12-07"
    try {
      await GenerateExercisePlanPdf({
        patientId: +localStorage.getItem("patientServerID")!,
        MasterPatientId: +localStorage.getItem("patientMasterID")!,
        visitId: visitId.visitId,
        recommendationDate: datetoPass,
        therapistId: +localStorage.getItem("therapistServerID")!,
        LocalDateTime: localDateTime(),
        EncryptedSystemId: localStorage.getItem("EncryptedSystemId"),
      })
        .then(async function (response: any) {
          setPrintingModal(false);
          printPdfForMobile(response.data);
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
          console.error(error);
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  const dismissPrintingModal = async (boolean: boolean) => {
    setPrintingModal(false);
  };

  const dismissPrintModal = async (boolean: boolean) => {
    setPrintModal(false);
  };

  let Window = window as any;
  Window["ReviewExerciseReference"] = {
    component: this,
    PrintPDFStatus: PrintPDFStatus,
  };

  function PrintPDFStatus(statusCode: number, statusMessage: string) {
    console.log("PrintPDFStatus", statusCode, statusMessage);
    setPrintDisable(false);
    if (statusCode == 1) {
      setPrintModal(true);
      setPrintActionModal(ActionType.SuccessPrintExercisePlan);
    } else {
      setPrintModal(true);
      setPrintActionModal(ActionType.ErrorPrintExercisePlan);
    }
  }
  const goToAddMoreExercises = () => {
    debugger;
    const combinedObject = {
      visitId: visitData?.visitData.visitId,
      exercisesRecommendationHistory:
        visitData?.visitData.exercisesRecommendationHistory,
      recommendationDate: visitData?.visitData.recommendationDate,
    };
    history.push("/assign-exercise", {
      exercisesRecommendationHistory: combinedObject,
    });
  };

  const handleClose = () => {
    console.log("patientDetails in duplicate", patientDetails);
    sessionStorage.setItem("patientDetails", JSON.stringify(patientDetails));
    window.location.href = window.location.origin + "/full-visit-summary";
  };

  return (
    <IonPage placeholder={undefined} className="page">
      <IonModal
        className="all-generic-new-modal-center-main-wrap"
        backdropDismiss={false}
        isOpen={printModal}
        placeholder={undefined}
      >
        <SuccessModal
          setShowModal={dismissPrintModal}
          actionType={printActionModal}
        ></SuccessModal>
      </IonModal>

      <IonModal
        className="all-generic-new-modal-center-main-wrap"
        backdropDismiss={false}
        isOpen={printingModal}
        placeholder={undefined}
      >
        <SuccessModal
          setShowModal={dismissPrintingModal}
          actionType={ActionType.LoadPrinting}
        ></SuccessModal>
      </IonModal>

      <TopLeftUserName
        headerText={"Duplicate Exercises"}
        printPDF={printPDF}
        // printDisable={printDisable}
      ></TopLeftUserName>

      <IonContent
        placeholder={undefined}
        className="duplicate-exercise-main-page slide-in-right"
      >
        <IonGrid
          className="container duplicate-exercise-page"
          placeholder={undefined}
        >
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <IonButton
                placeholder={undefined}
                className="add-more-ex-btn w-100"
                onClick={() => goToAddMoreExercises()}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 2L2 2L2 16L16 16L16 2ZM2 6.55651e-07L16 0C17.1046 1.19209e-07 18 0.895431 18 2L18 16C18 17.1046 17.1046 18 16 18L2 18C0.89543 18 5.96046e-07 17.1046 6.55651e-07 16L0 2C1.19209e-07 0.89543 0.895432 5.96046e-07 2 6.55651e-07Z"
                    fill="#005A75"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 9C4 8.44771 4.44772 8 5 8H13C13.5523 8 14 8.44771 14 9C14 9.55229 13.5523 10 13 10H5C4.44772 10 4 9.55229 4 9Z"
                    fill="#005A75"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 4C9.55228 4 10 4.44772 10 5V13C10 13.5523 9.55229 14 9 14C8.44772 14 8 13.5523 8 13V5C8 4.44772 8.44771 4 9 4Z"
                    fill="#005A75"
                  />
                </svg>
                Add More Exercises
              </IonButton>

              <div className="heading-sec">
                <h3>Assigned Exercise List</h3>
              </div>
              {previousExercise?.exercises.length > 0 ? (
                previousExercise.exercises.map(
                  (exercise: any, index: number) => {
                    return (
                      <DuplicateExercisesCard
                        key={index}
                        exercise={exercise}
                      ></DuplicateExercisesCard>
                    );
                  },
                )
              ) : (
                <p>No exercises selected</p>
              )}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>

      {previousExercise?.exercises.length > 0 && (
        <IonFooter
          className="ion-no-border duplicate-ex-page-footer"
          placeholder={undefined}
        >
          <IonGrid className="container" placeholder={undefined}>
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="two-col-btn">
                  <IonButton
                    placeholder={undefined}
                    className="blue-outline-btn"
                    onClick={() => handleClose()}
                  >
                    Cancel
                  </IonButton>
                  <IonButton
                    placeholder={undefined}
                    className="blue-btn"
                    onClick={() => history.replace("/review-exercises")}
                  >
                    Next
                  </IonButton>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonFooter>
      )}
    </IonPage>
  );
};
export default DuplicateExercises;
